import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable, InjectionToken } from '@angular/core';
import { Page, PageMetadata } from '@tran-monorepo/interfaces';
import { OrgUnit } from '@tran-monorepo/interfaces/applications';
import { Observable } from 'rxjs';

export const ORG_UNITS_API_URL = new InjectionToken<string>('ORG_UNITS_API_URL');

@Injectable({ providedIn: 'root' })
export class OrgUnitService {
    private readonly http = inject(HttpClient);
    private readonly apiUrl = inject(ORG_UNITS_API_URL);

    public getOrgUnits(page = 0, pageSize = 20): Observable<Page<OrgUnit, PageMetadata>> {
        const params = new HttpParams({ fromObject: { page, pageSize } });

        return this.http.get<Page<OrgUnit, PageMetadata>>(this.apiUrl, {
            params
        });
    }
}
